(function () {
    'use strict';

    angular
        .module('ib-ticket-selection-module')
        .controller('TicketSelectionController', TicketSelectionController);

    TicketSelectionController.$inject = ['$scope', '$filter', 'CheckinAppConstants'];
    function TicketSelectionController ($scope, $filter, CheckinAppConstants) {
        const vm = this;

        vm.checkSelectedSegments = checkSelectedSegments;
        vm.openSegmentInfo = openSegmentInfo;
        vm.selectShuttleSegment = selectShuttleSegment;
        vm.infoSegment = infoSegment;
        vm.showAircheckMessage = false;
        vm.$onInit = activate;

        ////////////////

        function activate () {
        }

        function checkSelectedSegments (index) {
            $scope.$emit('checkSelectedSegmentsEvent', index);
        }

        function openSegmentInfo (info) {
            $scope.$emit('openSegmentInfoEvent', info);
        }

        function selectShuttleSegment (selectedSegment) {
            $scope.$emit('selectShuttleSegmentEvent', selectedSegment);
        }

        function infoSegment (selectionInfo) {
            let literal = '';
            vm.showAircheckMessage = (selectionInfo?.airCheck?.status && selectionInfo?.airCheck?.url);

            /*if (Array.isArray(selectionInfo.passengersStatus) && selectionInfo.passengersStatus.length > 0) {
                selectionInfo.passengersStatus.forEach((pass) => {
                    if (pass.airCheckDocumentationRequired && Array.isArray(pass.inhibitBoardingCard) &&
                        pass.inhibitBoardingCard?.reason.includes(CheckinAppConstants.INHIBIT_BOARDING_CARD_TYPES.AIRCHECK_REASON)) {
                        isInhibitBCAircheckReason = true;
                    }
                });
            }*/

            if (selectionInfo?.detailedType === 'OPEN') {
                literal = 'IBCOAC_TICKET_OPEN_TEXT';
            } else {
                switch (selectionInfo.segmentStatus) {
                        case CheckinAppConstants.FLIGHT_PASSENGERS_STATUS.AVAILABLE:
                            literal = 'IBCOAC_CK_PASS_ABIERTO';
                            break;
                        case CheckinAppConstants.FLIGHT_PASSENGERS_STATUS.SELECTABLE:
                            literal = 'IBCOAC_CK_TICKET_GDR';
                            break;
                        case CheckinAppConstants.FLIGHT_PASSENGERS_STATUS.CHECKED:
                            if (showAircheckReason()) {
                                literal = 'IBCOAC_TICKET_CHECKED_TEXT_AIRCHECK';
                            } else {
                                literal = 'IBCOAC_TICKET_CHECKED_TEXT';
                            }
                            break;
                        case CheckinAppConstants.FLIGHT_PASSENGERS_STATUS.NOT_AVAILABLE:
                            literal = 'IBCOAC_PA_SEGMENT_FOOTER_UNCHECKABLE';
                            vm.showAircheckMessage = false;
                            break;
                        default:
                            break;
                }
            }
            return $filter('translate')(literal);

            function showAircheckReason () {
                const firstPassenger = selectionInfo.passengersStatus[0];
                const REASONS = CheckinAppConstants.INHIBIT_BOARDING_CARD_TYPES;
                return selectionInfo.passengersStatus?.length > 0 &&
                    Array.isArray(firstPassenger.inhibitBoardingCard) &&
                    (firstPassenger.inhibitBoardingCard?.reason.includes(REASONS.AIRCHECK_REASON) ||
                    firstPassenger.inhibitBoardingCard?.reason.includes(REASONS.BOKO_AIRCHECK_REASON));
            }
        }
    }
})();
